import enNotification from "./en";
import frNotification from "./fr";
import deNotification from "./de";

export { enNotification, frNotification, deNotification };
